import { U2bTableData } from '@core/components/layout/table/table.types';
import { BcmUserTableSettingKey } from '@shared/models/bcm-settings-user';
import { getIsActive } from '@core/functions/get-is-active';

export const costCentersTableData: U2bTableData = {
    tableId: BcmUserTableSettingKey.CostCenters,
    hasServerSideFiltering: true,
    columnDefinitions:  [
        {
            property: 'name',
            name: 'Name',
            isActive: getIsActive(),
            translationKey: 'table.name',
            exportKey: 'name',
            filter: {},
        },
        {
            property: 'abbreviation',
            name: 'Kürzel',
            isActive: getIsActive(),
            translationKey: 'table.abbreviation',
            exportKey: 'abbreviation',
            filter: {},
        },
        {
            property: 'number',
            name: 'Nummer',
            isActive: getIsActive(),
            translationKey: 'table.number',
            exportKey: 'number',
            filter: {},
        },
        {
            property: 'description',
            name: 'Beschreibung',
            isActive: getIsActive(),
            translationKey: 'table.description',
            exportKey: 'description',
            filter: {},
        },
    ]
};
